import React from 'react';
import Hero from '../components/Hero';
import ServicesSection from '../components/ServicesSection';
import AboutSection from '../components/AboutSection';
import ContactSection from '../components/ContactSection';
import CTASection from '../components/CTASection';

const Home: React.FC = () => {
  return (
    <div>
      <Hero />
      <ServicesSection />
      <AboutSection />
      <ContactSection />
      <CTASection />
    </div>
  );
};

export default Home;